var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-zone"},[_c('div',{staticClass:"container"},[_c('search-filter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }